import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-forgot-password',
  imports: [TranslateModule, CommonModule],
  templateUrl: './login-option.component.html'
})
export class LoginOptionComponent {
  @Input() text!: string;
  @Input() class?: string;
  @Input() action?: () => void;
}
